<template>
  <div class="video-container"  style="max-width: 100%; height:100%; position: relative" >

      <div v-if="playing&&waiting" style=" position:absolute; display: flex; width: 100%; height:100%;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    align-content: center;
    justify-content: center; " >
        <svg style="width: 120px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><radialGradient id="a1" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)"><stop offset="0" stop-color="#FFFFFF"></stop><stop offset=".3" stop-color="#FFFFFF" stop-opacity=".9"></stop><stop offset=".6" stop-color="#FFFFFF" stop-opacity=".6"></stop><stop offset=".8" stop-color="#FFFFFF" stop-opacity=".3"></stop><stop offset="1" stop-color="#FFFFFF" stop-opacity="0"></stop></radialGradient><circle transform-origin="center" fill="none" stroke="url(#a1)" stroke-width="16" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70"><animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform></circle><circle transform-origin="center" fill="none" opacity=".2" stroke="#FFFFFF" stroke-width="16" stroke-linecap="round" cx="100" cy="100" r="70"></circle></svg>
      </div>

    <video ref="videoPlayer" class="dash-video" playsinline   style="width: 100%; height:100%"></video>
  </div>
</template>

<script>


import LoadingBuffer from "@/components/layout/template-1/global/widgets/LoadingBuffer.vue";
import moment from "moment";

export default {
  name: "VideoPlayerCustom",
  components: {LoadingBuffer},
  props: {
    src: {
      type: String,
      required: false,
    },
    options: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      waiting: false,
      logs: '',
      quality: null,
      seeking: false,
      playing: false,
      player: null,
      startedPlaying: false,
      time: 0,
      totalTime: 0,
      progress: 0,
      bufferStartTime: 0,
    };
  },
  watch: {
    seeking(newVal,oldVal) {

      if (!newVal&&oldVal) {
        this.player.seek(this.totalTime * (this.progress / 100));
      }
    },
  },
  mounted() {
    this.initDashPlayer();
  },
  methods: {
    initDashPlayer() {
      if (this.options.mpdUrl) {
        this.player = dashjs.MediaPlayer().create();
        this.player.updateSettings({
          debug: {
           logLevel:3,
           dispatchEvent: true
          },

          streaming: {
            scheduling: {
             scheduleWhilePaused: this.options.preload
            },
            buffer:{
              bufferTimeDefault:18,
              bufferToKeep:10,
              bufferTimeAtTopQuality: 30,
             // initialBufferLevel: 1,
              fastSwitchEnabled: false,
             flushBufferAtTrackSwitch:true
            },
            abr: {
            //  usePixelRatioInLimitBitrateByPortal: true,
              minBitrate: {
               video : 1000,
              },initialBitrate: {
               video : 4500,
                // video : 100,
              },
              autoSwitchBitrate: {
                video: true, // Disable auto bitrate switching for video
              }
            }
          }
        })
        console.log(this.options)
        this.player.initialize(this.$refs.videoPlayer, this.options.mpdUrl, false);
        this.player.setMute(!!this.options.mute);
        this.player.on(dashjs.MediaPlayer.events.PLAYBACK_STARTED, () => {
          this.log('PLAYBACK_STARTED')
          if(!this.startedPlaying){
            this.player.seek(0.01);
          }
          this.startedPlaying = true;
          this.playing = true;


          this.$emit('playing')
          this.$emit('started')
          if(!this.isDesktop && this.player.getCurrentRepresentationForType('video').width<this.player.getCurrentRepresentationForType('video').height){
            this.$emit('fullScreen', true)
          }
          setTimeout(()=>{
            if(this.playing){
              this.$emit('playing')
            }
          },1000)
        });
        this.player.on(dashjs.MediaPlayer.events.PLAYBACK_PAUSED, () => {

        this.player.updateSettings({


          streaming: {
            scheduling: {
              scheduleWhilePaused: true
            },

          }
        })
          this.$emit('paused')
          this.log('PLAYBACK_PAUSED')
          this.playing = false;
        });
      }

      this.player.on(dashjs.MediaPlayer.events.PLAYBACK_ENDED, () => {
        this.log('PLAYBACK_ENDED')
        this.playing = false;
        this.startedPlaying = false;
        this.$emit('ended')
      });
      this.player.on(dashjs.MediaPlayer.events.PLAYBACK_PROGRESS, (e) => {
        console.log('PLAYBACK_PROGRESS',this.player.getBufferLength('video'))
        if(!this.player.getBufferLength('video')){
          this.waiting = true
        }
        if(this.bufferStartTime){
          console.warn('buffer time', moment().diff(this.bufferStartTime, 'seconds'))

          if(moment().diff(this.bufferStartTime, 'seconds')>3){
            this.player.updateSettings({

              streaming: {
                buffer:{
                  bufferToKeep:20,
                  fastSwitchEnabled: true,
                },
                abr: {
                  //  usePixelRatioInLimitBitrateByPortal: true,
                  minBitrate: {
                    video : 500,
                  },initialBitrate: {
                    video : 3000,
                    // video : 100,
                  },
                  autoSwitchBitrate: {
                    video: false, // Disable auto bitrate switching for video
                  }
                }
              }
            })
            this.player.play()
          }

        }


      });

      this.player.on(dashjs.MediaPlayer.events.STREAM_INITIALIZING, (e) => {

        this.log('STREAM_INITIALIZING')
        console.log('STREAM_INITIALIZING',e)
        this.$emit('ready')
        this.$emit('loaded')

      });
      this.player.on(dashjs.MediaPlayer.events.PLAYBACK_METADATA_LOADED, (e) => {

        this.log('PLAYBACK_METADATA_LOADED')
        console.log('PLAYBACK_METADATA_LOADED',e)

      });
      this.player.on(dashjs.MediaPlayer.events.FRAGMENT_LOADING_STARTED, (e) => {

        this.log('FRAGMENT_LOADING_STARTED')
        console.log('FRAGMENT_LOADING_STARTED',e)

      });
      this.player.on(dashjs.MediaPlayer.events.FRAGMENT_LOADING_STARTED, (e) => {
        console.info('FRAGMENT_LOADING_STARTED',this.player.getBufferLength('video'),this.playing)
        if(!this.player.getBufferLength('video')){
          this.waiting = true
        }
        if(this.playing&&!this.bufferStartTime){
          this.bufferStartTime = moment()
        }
        this.log('PLAYBACK_WAITING')
        console.log('PLAYBACK_WAITING',e)

      });
      this.player.on(dashjs.MediaPlayer.events.PLAYBACK_LOADED_DATA, (e) => {

        this.log('PLAYBACK_LOADED_DATA')
        console.log('PLAYBACK_LOADED_DATA',e)

      });
      this.player.on(dashjs.MediaPlayer.events.PLAYBACK_SEEKED, (e) => {

        this.log('PLAYBACK_SEEKED')
        console.log('PLAYBACK_SEEKED',e)

      });
      this.player.on(dashjs.MediaPlayer.events.BUFFER_EMPTY, (e) => {

        if (e.mediaType === 'Video') {
          console.log('Video buffer is empty, playback may stall.');

            this.waiting = true

        }

        this.log('BUFFER_EMPTY')
        console.log('BUFFER_EMPTY',e)

      });

      this.player.on(dashjs.MediaPlayer.events.BUFFER_LOADED, (e) => {

        this.log('BUFFER_LOADED')
        console.log('BUFFER_LOADED',e)

      });
      this.player.on(dashjs.MediaPlayer.events.QUALITY_CHANGE_RENDERED, (e) => {
      console.log('QUALITY_CHANGE_RENDERED',this.player.getCurrentRepresentationForType('video').width)
        this.log('QUALITY_CHANGE_RENDERED '+ this.player.getCurrentRepresentationForType('video').width)
      });
      this.player.on(dashjs.MediaPlayer.events.PLAYBACK_TIME_UPDATED, (e) => {

       this.quality = this.player.getCurrentRepresentationForType('video').width
        this.waiting= false
        console.log('PLAYBACK_TIME_UPDATED',e)
        if(this.bufferStartTime){
         console.warn('buffer time', moment().diff(this.bufferStartTime, 'seconds'))

          if(moment().diff(this.bufferStartTime, 'seconds')>2){
            this.player.updateSettings({

              streaming: {

                abr: {
                  //  usePixelRatioInLimitBitrateByPortal: true,
                  minBitrate: {
                    video : 1,
                  },
                  autoSwitchBitrate: {
                    video: true, // Disable auto bitrate switching for video
                  }
                }
              }
            })
          }
          this.bufferStartTime =0
          this.player.play()


        }

        if(this.seeking){
          return
        }
       // this.$emit('playing')
        this.time = e.time
        this.progress = (e.time / this.totalTime) * 100
        console.log({percent:(e.time / this.totalTime) , seconds : this.time})
        this.$emit('timeupdate', {...e, percent:(e.time / this.totalTime) , seconds : this.time})

      });

      this.player.on('log',  (event) =>{
       this.log(event)
      });
      this.player.on('ERROR', (event)  =>{
       this.log(`[ERROR] ${event.message}`, JSON.stringify(event));
      });

      this.player.on(dashjs.MediaPlayer.events.CAN_PLAY, (e) => {

        this.log(this.player.getRepresentationsByType('video'))
        console.log('bitrateList',this.player.getRepresentationsByType('video')  )
      ///  this.player.setRepresentationForTypeByIndex('video',(this.player.getRepresentationsByType('video').length -1)  ,true);

        // this.player.seek(0);
        this.totalTime = this.player.duration()
        console.log('CAN_PLAY',this.player.duration())
        this.$emit('ready')
        this.$emit('loaded')
      });

    },
    replay() {
      this.player.seek(0);
      this.play();
    },
    play() {


      this.player.play();
    },
    pause() {
      this.player.pause();
    },
    stop() {
      this.$refs.videoPlayer.pause();
      this.$refs.videoPlayer.currentTime = 0;
    },
    log(log){
    // console.log(log)
    },
    seekToPosition(position, isVideoPlaying){
      if(isVideoPlaying){
        this.player.play()
      }
      this.player.seek((this.totalTime * position)/100);
    },
    setMuted() {
      this.player.setMuted(true);
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.destroy();
    }
  },
};
</script>
